import type { ModelDefinition } from "@/models.js";

export const xiaomiModels = [
	{
		id: "mimo-v2.5-pro",
		name: "MiMo V2.5 Pro",
		description:
			"Xiaomi's flagship 1T-parameter model with 42B activations, 1M ultra-long context, and deep thinking capabilities. Performs comparably to Claude Opus 4.6 in agent scenarios.",
		family: "xiaomi",
		releasedAt: new Date("2026-04-23"),
		providers: [
			{
				providerId: "xiaomi" as const,
				externalId: "mimo-v2.5-pro",
				inputPrice: "0.435e-6",
				outputPrice: "0.87e-6",
				cachedInputPrice: "0.087e-6",
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 131072,
				streaming: true,
				reasoning: true,
				vision: false,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "mimo-v2-pro",
		name: "MiMo V2 Pro",
		description:
			"Xiaomi's 1T-parameter model with 42B active parameters and 1M context window using hybrid Global Attention + SWA architecture.",
		family: "xiaomi",
		releasedAt: new Date("2026-03-18"),
		providers: [
			{
				providerId: "xiaomi" as const,
				externalId: "mimo-v2-pro",
				inputPrice: "1e-6",
				outputPrice: "3e-6",
				cachedInputPrice: "0.2e-6",
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 131072,
				streaming: true,
				reasoning: true,
				vision: false,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "mimo-v2.5",
		name: "MiMo V2.5",
		description:
			"Xiaomi's full-modal perception model supporting native understanding of images, videos, audio, and text with 1M context. Agent performance comparable to MiMo V2.5 Pro.",
		family: "xiaomi",
		releasedAt: new Date("2026-04-23"),
		providers: [
			{
				providerId: "xiaomi" as const,
				externalId: "mimo-v2.5",
				inputPrice: "0.14e-6",
				outputPrice: "0.28e-6",
				cachedInputPrice: "0.028e-6",
				requestPrice: "0",
				contextSize: 1000000,
				maxOutput: 131072,
				streaming: true,
				reasoning: true,
				vision: true,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "mimo-v2-omni",
		name: "MiMo V2 Omni",
		description:
			"Xiaomi's multimodal model supporting text, vision, and speech modalities with 256K context window.",
		family: "xiaomi",
		releasedAt: new Date("2026-03-18"),
		providers: [
			{
				providerId: "xiaomi" as const,
				externalId: "mimo-v2-omni",
				inputPrice: "0.4e-6",
				outputPrice: "2e-6",
				cachedInputPrice: "0.08e-6",
				requestPrice: "0",
				contextSize: 256000,
				maxOutput: 131072,
				streaming: true,
				reasoning: false,
				vision: true,
				tools: true,
				jsonOutput: true,
			},
		],
	},
	{
		id: "mimo-v2-flash",
		name: "MiMo V2 Flash",
		description:
			"Xiaomi's high-efficiency inference model with hybrid architecture, 3 MTP layers for 2.5-3.7x faster inference, and 256K context.",
		family: "xiaomi",
		releasedAt: new Date("2025-12-16"),
		providers: [
			{
				providerId: "xiaomi" as const,
				externalId: "mimo-v2-flash",
				inputPrice: "0.1e-6",
				outputPrice: "0.3e-6",
				cachedInputPrice: "0.02e-6",
				requestPrice: "0",
				contextSize: 256000,
				maxOutput: undefined,
				streaming: true,
				reasoning: true,
				reasoningOutput: "omit" as const,
				vision: false,
				tools: true,
				jsonOutput: true,
				// Xiaomi retires mimo-v2-flash and auto-forwards requests to
				// mimo-v2.5 (billed as the new model) at Beijing 2026-06-18 00:00.
				// Deactivate at the switch so requests error instead of silently
				// routing to a different model.
				deactivatedAt: new Date("2026-06-17T16:00:00Z"),
			},
		],
	},
] as const satisfies ModelDefinition[];
